import * as React from 'react';

const ChevronDownIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={10}
    fill="none"
    {...props}
  >
    <path
      d="M14.667.304 16 1.69 8 10 0 1.69 1.333.303 8 7.23 14.667.304Z"
      fill="#78879A"
    />
  </svg>
);

export default ChevronDownIcon;
